import { captureException } from '@sentry/react'
import { type UseQueryOptions, useQuery } from '@tanstack/react-query'
import {
	type HttpGetFlagsOptions,
	HttpGetFlagsResponse,
	httpGetFlags
} from '@/features/photoset/http/photoset.http'
import { parseAxiosPromise } from '@/helpers/utils'
import { QUERY_KEYS } from '@/query-client'

export const useGetFlags = (
	promiseArgs: HttpGetFlagsOptions,
	options?: Omit<
		UseQueryOptions<HttpGetFlagsResponse>,
		'queryFn' | 'queryKey'
	>
) =>
	useQuery({
		...options,
		queryKey: [QUERY_KEYS.FLAGS, promiseArgs],
		queryFn: () =>
			parseAxiosPromise({
				axiosPromise: httpGetFlags(promiseArgs),
				responseShape: HttpGetFlagsResponse,
				onZodError: captureException
			})
	})
